<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="修改归属"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="650px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap pr20 mt20">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="100px">
                <el-form-item label=" 推广内容：">
                    <div class="font12px mt8">
                        <p class="ellipsis sub-row-p">
                            <span class="inline-block ver-middle ellipsis" style="max-width: 250px;" :title="data.subproject_name+'('+data.subproject_id+')'">{{data.subproject_name||'--'}}（{{data.subproject_id}}）</span>
                        </p>
                        <p class="ellipsis sub-row-p" :title="data.subproject_content">{{data.subproject_content||'--'}}</p>
                    </div>
                </el-form-item>
                <el-form-item label=" 当前归属：">
                    <p class="mt8 font12px">{{data.project_name}}</p>
                </el-form-item>
                <el-form-item label=" 新归属：" prop="plat_id_subitem_id">
                    <ESelect
                        style="width: 300px;"
                        v-model="formItem.plat_id_subitem_id"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请选择新归属项目"
                        :remote-method="remoteMethod"
                        :loading="remoteLoading">
                        <el-option
                            v-for="item in projectList"
                            :key="item.project_id"
                            :label="item.project_name"
                            :value="item.project_id">
                        </el-option>
                    </ESelect>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20" v-matomo="{behaviorCategory: '项目管理',name: '列表(编辑-项目归属-取消)' }">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '项目管理',name: '列表(编辑-项目归属-提交)' }">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/baseInfo/project.js';
    import matomoFun from "@/utils/matomo.js";

    export default {
        name: "EditSubProjectModal",
        components:{},
        props:{
            data:Object,
        },
        data(){
            return {
                dialogVisible:false,
                formItem:{
                    plat_id_subitem_id:'',
                },
                rules:{
                    plat_id_subitem_id:[
                        { required: true, message: '请选择新归属项目', trigger: 'blur' },
                    ],
                },
                submitLoading:false,
                remoteLoading:false,
                projectList:[],

            }
        },
        methods:{
            handleClose(){
                matomoFun.trackEvent('项目管理', '点击', '列表(编辑-项目归属-取消)');
                this.resetForm();
                this.dialogVisible = false;
                this.$refs.form.clearValidate();
            },
            showModal(){
                this.dialogVisible = true;
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        API.editSubProject({
                            plat_id:this.data.plat_id,
                            subitem_id:this.data.subitem_id,
                            project_id:this.formItem.plat_id_subitem_id,
                        }).then(res=>{
                            console.log('editSubProject',res);
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.hideModal();
                            this.$emit('update',this.data);
                        },err=>{
                            console.log('editSubProject err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'操作失败');
                        })
                    } else {
                        return false;
                    }
                });
            },
            hideModal(){
                console.log('hideModal');
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formItem.plat_id_subitem_id = '';
                this.submitLoading = false;
                this.projectList = [];
            },
            remoteMethod(query){
                if (query !== '') {
                    this.remoteLoading = true;
                    API.getProjectList({
                        search:query,
                    }).then(res => {
                        this.projectList = res.data || [];
                        this.remoteLoading = false;
                    }, (err) => {
                        console.log('getProjectList error', err);
                        this.projectList = [];
                        this.remoteLoading = false;
                    });
                } else {
                    this.projectList = [];
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__body{
        padding: 10px 30px 20px;
    }

    ::v-deep .word-limit-input input{
        padding-right: 80px;
    }

    .ver-middle{
        vertical-align: middle;
    }
    .sub-row-p{
        line-height: 16px;
    }

</style>
